"use client"
import React, { useState } from 'react';
import {PORTAL_URL} from '../../Constants';
import { useEffect } from 'react'
import axios from "axios";
import { endPoints } from "../../Constants";
import { useTranslation,Trans  } from 'react-i18next';

const Stakeholders = () => {
    const { t,i18n } = useTranslation();
    // State to store the selected dropdown option
    const [selectedOption, setSelectedOption] = useState('101');
    const  RegisterURL = {PORTAL_URL} +"/create-account";
  const [TypeOfStakeholderList, setTypeOfStakeholderList] = useState([]);
    useEffect(() => {
        const token = localStorage.getItem('token');
        debugger;
        axios.get(`${endPoints.getTypeOfStakeholderList}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        })
          .then((res) => {
            debugger;
            const typeOfStakeholderList = JSON.parse(res.data.data);
            setTypeOfStakeholderList(typeOfStakeholderList);
    
          })
          .catch((err) => {
            console.error("Error fetching data:", err);
          });
      }, []);

    // Handler for dropdown selection change
    const handleDropdownChange = (event) => {
        setSelectedOption(event.target.value);
    };

    // Data for each option (contains two items for each option)
    const contentData = {
        '102': [
            {
                heading: t('eligibility'),
                description: t('eligibilityDesc102')
            },
            {
                heading: t('role'),
                description:  t('roleDesc102')
            }
        ],
        '101': [
            {
                heading: t('eligibility'),
                description:   t('eligibilityDesc101')
            },
            {
                heading: t('role'),
                description:  t('roleDesc101')
            }
        ],
        '107': [
            {
                heading: t('eligibility'),
                description: t('eligibilityDesc107a'),
                description2: t('eligibilityDesc107b'),

            },
            {
                heading: t('role'),
                description:  t('roleDesc107')
            }
        ],

        '104': [
            {
                heading: t('eligibility'),
                description: t('eligibilityDesc104')
            },
            {
                heading: t('role'),
                description:  t('roleDesc104')
            }
        ],
        '110': [
            {
                heading: t('eligibility'),
                description:   t('eligibilityDesc110')
            },
            {
                heading: t('role'),
                description: t('roleDesc110')
            }
        ],
        '103': [
            {
                heading: t('eligibility'),
                description:  t('eligibilityDesc103')
            },
            {
                heading: t('role'),
                description: t('roleDesc103')
            }
        ],
        '106': [
            {
                heading: t('eligibility'),
                description:  t('eligibilityDesc106')
            },
            {
                heading: t('role'),
                description: t('roleDesc106')
            }
        ],
        '105': [
            {
                heading: t('eligibility'),
                description:  t('eligibilityDesc105')
            },
            {
                heading: t('role'),
                description: t('roleDesc105')
            }
        ],
        '108': [
            {
                heading: t('eligibility'),
                description:  t('eligibilityDesc108')
            },
            {
                heading: t('role'),
                description: t('roleDesc108')
            }
        ],
        '111': [
            {
                heading: t('eligibility'),
                description:  t('eligibilityDesc111')
            },
            {
                heading: t('role'),
                description: t('roleDesc111')
            }
        ],
        '112': [
            {
                heading: t('eligibility'),
                description: t('eligibilityDesc112')
            },
            {
                heading: t('role'),
                description: t('roleDesc112')
            }
        ],
        
        '109': [
            {
                heading: t('eligibility'),
                description: t('eligibilityDesc109')
            },
            {
                heading: t('role'),
                description: t('roleDesc109')
            }
        ],
        '113': [
            {
                heading: t('eligibility'),
                description: t('eligibilityDesc113')
            },
            {
                heading: t('role'),
                description: t('roleDesc113')
            }
        ],
        '114': [
            // {
            //     heading: t('eligibility'),
            //     description: 'Description for the first content item under Option 3.'
            // },
            {
                heading: t('role'),
                description: t('roleDesc114')
            }
        ]
        
    };

    // Render content based on the selected option
    const renderContent = () => {
        const selectedContent = contentData[selectedOption];

        return (
            <div className="content-wrapper" data-aos="fade-in" data-aos-delay="200">
                {selectedContent.map((item, index) => (
                    <div className="content-item" key={index}>
                        <div className="icon">
                            <span className="icon-list-icon"></span>
                        </div>
                        <div className='text-content'>
                            <h3 className="heading">{item.heading}</h3>
                           <p dangerouslySetInnerHTML={{ __html: item.description }} />
                            <p className="description">{item.description2}</p>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    

    return (
        <section className="lyt-section typ-stakholder-sec">
            <div className="container">
                <div className="heading-wrapper">
                    <div data-aos="fade-in" data-aos-delay="200">
                        <h2 className="bs-heading typ25 typdblue"dangerouslySetInnerHTML={{ __html: t('stakeholdersTitle') }} />
                    </div>

                    <a className="bs-btn typfill" href={PORTAL_URL} aria-label="Navigate to Contact Us page" data-aos="fade-in" data-aos-delay="300">
                        {t('enrollNow')}<span className="icon icon-right-arrow"></span>
                    </a>
                </div>

                {/* Dropdown Menu */}
                <div className="dropdown-wrapper">
                    <p className='bs-para mb-2' data-aos="fade-in" data-aos-delay="200">{t('selectYourcategory')}</p>
                    <div className="dropdown" data-aos="fade-in" data-aos-delay="300">
                        <select

                            value={selectedOption}
                            onChange={handleDropdownChange}
                        >
                            {TypeOfStakeholderList.map((provider) => (
                                <option key={provider.ID} value={provider.SUB_TYPE_CODE}>
                                    {i18n.language === 'mr' ? provider.SUB_TYPE_Mr :provider.SUB_TYPE}
                                </option>))}
                            {/* <option value="101">Architects</option>
                            <option value="108">Civil Engineers</option>
                            <option value="105">Contractors </option>
                            <option value="104">Developer </option>
                            <option value="110">Development Manager</option>
                            <option value="103">Finance Professional</option>
                            <option value="113">Financial Institutions like Banks, HFCs and AIFs</option>
                            <option value="102">Legal Professionals</option>
                            <option value="112">Mediators </option>
                            <option value="107">Project Management Consultants (PMCs) </option>
                            <option value="109">Real Estate Agents </option>
                            <option value="111">Structural Engineers </option>                            
                            <option value="106">Suppliers </option>
                            <option value="114">Third Party Monitoring Individuals/Companies</option> */}
                        </select>
                    </div>
                </div>

                {/* Render Content Based on Dropdown Selection */}
                {renderContent()}
            </div>
        </section>
    );
};

export default Stakeholders;
